import { immer } from 'zustand/middleware/immer';
export const zustandImmerMiddleware = immer;
